var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99989 0.0625C4.81712 0.0625 4.63426 0.129639 4.49498 0.263916L0.209263 4.38892C-0.0697545 4.65747 -0.0697545 5.09253 0.209263 5.36108C0.488281 5.62964 0.94029 5.62964 1.21931 5.36108L4.99989 1.72109L8.78114 5.36055C9.06016 5.6291 9.51217 5.6291 9.79118 5.36055C10.0702 5.09199 10.0702 4.65693 9.79118 4.38838L5.50547 0.263379C5.36596 0.129102 5.18292 0.0625 4.99989 0.0625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevronUp.9c4e75daaf4e89a964665878c7cd0107.svg";
export { ForwardRef as ReactComponent };